export const APP_CENTER_API_URL = 'https://aks-cluster-prod.westus3.cloudapp.azure.com';
